import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "checkboxes" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value", "checked"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value", "checked"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dig-input-text", {
      value: _ctx.demand.free,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update('free', $event.target.value)))
    }, _toDisplayString(_ctx.$t('search')), 41, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dig-input-checkbox-wrapper", {
        label: "Priorité",
        value: _ctx.demand.priority,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('priority', $event.detail)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priorities, (priority) => {
          return (_openBlock(), _createElementBlock("dig-input-checkbox", {
            key: priority,
            value: priority,
            checked: _ctx.demand.priority.includes(priority)
          }, _toDisplayString(_ctx.$t('Demand.Priority.' + priority)), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3),
      _createElementVNode("dig-input-checkbox-wrapper", {
        label: "État",
        value: _ctx.demand.state,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update('state', $event.detail)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
          return (_openBlock(), _createElementBlock("dig-input-checkbox", {
            key: state,
            value: state,
            checked: _ctx.demand.state.includes(state)
          }, _toDisplayString(_ctx.$t('Demand.State.' + state)), 9, _hoisted_6))
        }), 128))
      ], 40, _hoisted_5)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("dig-ui-standard-button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reset())),
        class: "cancel"
      }, _toDisplayString(_ctx.$t('reset')), 1),
      _createElementVNode("dig-ui-standard-button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
      }, _toDisplayString(_ctx.$t('search')), 1)
    ])
  ]))
}